export default "__VITE_ASSET__f50783f9__"